
<app-form-multi-select
    [options]="statusEntities$ | async"
    [value]="statusCurrentValue$ | async"
    (valueChange)="statusValueChange($event)"
    [defer]="0"
    [placeholder]="'ci.common.status' | translate"
></app-form-multi-select>